<script setup lang="ts">
const { navIgnoreMainViewGestures } = useGlobals()
const { tauriState } = useTauri()
const { isOnPreviewPage, currentSharedFolderHome } = useNavigation()
const { state: sidebarState } = useSidebar()
const { state: mainViewState } = useMainView()
</script>

<template>
  <div class="header">
    <nav-window-menu-mac
      v-if="tauriState.platform === 'macos' && !sidebarState.state"
      class="island mac"
    />
    <nav-user v-if="!sidebarState.state" />
    <nav-history
      v-if="isDesktop()"
      :class="[navIgnoreMainViewGestures]"
    />
    <notification-tray
      :class="[navIgnoreMainViewGestures]"
    />

    <div class="spacer" />

    <nav-omni-bar
      v-if="!['settings', 'agent'].includes(mainViewState.state)"
      class="omni"
    >
      <!-- <nav-instant-menu v-if="instantState.visible" />
      <nav-path
        v-else-if="!isOnSearchPage()"
        class="island flex-basis-auto"
      />
      <nav-search v-else class="island flex-basis-auto" /> -->
    </nav-omni-bar>

    <div
      v-if="!['settings', 'agent'].includes(mainViewState.state)"
      class="spacer justify-end"
    >
      <nav-sharing-pill
        v-if="currentSharedFolderHome"
        class="island"
        :class="[navIgnoreMainViewGestures]"
      />
      <nav-preview-mode
        v-if="isOnPreviewPage()"
        class="island"
        :class="[navIgnoreMainViewGestures]"
      />
      <nav-view-mode
        v-else
        class="island"
        :class="[navIgnoreMainViewGestures]"
      />
      <nav-window-menu-windows
        v-if="tauriState.platform === 'windows'"
        class="island windows"
      />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.header
  @apply absolute top-0 w-full max-h-screen p-[#{$nav-btz-gap-pills}]
  @apply flex justify-between gap-[#{$nav-gap-pills}]
  @apply pointer-events-none
  @apply

.island
  @apply pointer-events-auto z-navigation-layer
  &.mac
    @apply -mt-3 -ml-3
  &.windows
    @apply -mt-3 -mr-3

.spacer
  @apply flex shrink-10000 flex-basis-[400px] gap-3

.omni
  @apply flex flex-grow justify-center gap-3
</style>
